import React from 'react'

const Charts = (props) => <div className='Charts'>{props.children}</div>

export default Charts


// WEBPACK FOOTER //
// ./src/shared/javascripts/components/Charts.jsx